module.exports = __webpack_public_path__ + "static/bg-header-online-tools-119cd4f3c91a9d8d7778ca399cb46c8a.svg";